import { ActionTabsController } from './actionTabs.controller';
import template from './actionTabs.html';

export const actionTabsComponent = {
  name: 'actionTabs',
  restrict: 'E',
  template,
  controller: ActionTabsController,
  controllerAs: 'vm',
  bindings: {
    tabs: '<',
    currentTab: '<',
    onChange: '&',
    title: '@',
    className: '@',
    template: '@'
  }
};
